// Pages
import ProjectRegister from "pages/Project/Register"
import ProjectTransaction from "pages/Project/Transaction"
import EditProject from "pages/Project/Transaction/Edit"
import ViewProject from "pages/Project/Transaction/View"
import { ListApproveProject } from "pages/Setup/Preference/ApproveProject/ListApproveProject"

// Types
import type { RouteType } from "types"

export const projectRoutes: RouteType[] = [
  {
    path: "",
    element:<ProjectRegister />,
    permission: "SUBSCRIBED"
  },
  {
    path: "/project/approve-project",
    element: <ListApproveProject />,
    permission: "ST10"
  },

  {
    path: "/project/create",
    element: <ProjectTransaction />,
    permission: "SUBSCRIBED"
  },
  {
    path: "/project/edit/:id",
    element: <EditProject />,
    permission: "SUBSCRIBED"
  },
  {
    path: "/project/view/:id",
    element: <ViewProject />,
    permission: "SUBSCRIBED"
  }
]